
import { defineComponent } from 'vue';
import AdImage from './AdImage.vue';
import AdDetailGalleryTopButtons from './AdDetailGalleryTopButtons.vue';
import config from '@/shared/constants/config';
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'swiper/vue';
import LightBox from '@/shared/components/LightBox/LightBox.vue';
import { adService } from '../AdService';

export default defineComponent({
  name: 'AdDetailGallery',
  components: {
    AdImage,
    LightBox,
    Swiper,
    SwiperSlide,
    AdDetailGalleryTopButtons,
  },
  emits: ['navigate', 'streetview', 'virtualtour', 'video'],
  props: {
    adGuid: String,
    parentAdGuid: String,
    alt: String,
    showStreetView: Boolean,
    virtualTourLink: String,
    videoLink: String,
    estateType: {
      required: true,
      type: Number,
    },
    estateSubType: {
      required: true,
      type: Number,
    },
    images: Array,
    parentImages: Array,
    maxCount: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      selectedIndex: 0,
      allImages: [] as any[],
      thumbs: [] as any[],
      media: [] as any[],
      swiper: null as any,
    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    imageHeight(): number {
      return this.isMobile ? 675 : 675;
    },
    imageWidth(): number {
      return this.isMobile ? 1100 : 1100;
    },
    hasImages(): boolean {
      return this.allImages ? this.allImages.length > 0 : false;
    },
    selected(): any {
      return this.allImages ? this.allImages[this.selectedIndex] : null;
    },
  },
  created() {
    if (this.parentImages) {
      this.allImages = this.parentImages.map((image) => {
        return {
          adGuid: this.parentAdGuid,
          image: image,
        };
      });
    }
    if (this.images) {
      this.allImages.push(
        ...this.images.map((image) => {
          return {
            adGuid: this.adGuid,
            image: image,
          };
        }),
      );
    }
    if (this.allImages) {
      this.media = this.allImages.map((file) => {
        const obj = {} as any;
        obj.thumb = config.BASE_URL + '/files/pictures/' + file.adGuid + '/' + file.image;
        obj.src = config.BASE_URL + '/files/pictures/' + file.adGuid + '/' + file.image;
        return obj;
      });
      if (this.allImages.length > 1) {
        this.thumbs = this.allImages.slice(1, this.maxCount + 1);
      }
    }
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    onPrevious() {
      if (this.swiper) {
        this.swiper.slidePrev();
      }
      adService.view(this.adGuid);
    },
    onNext() {
      if (this.swiper) {
        this.swiper.slideNext();
      }
      adService.view(this.adGuid);
    },
    onSelect(index: number) {
      if (this.isMobile) {
        return;
      }
      //this.selectedIndex = index;
      if (this.$refs.lightbox) {
        (this.$refs.lightbox as any).showImage(index);
      }
      adService.view(this.adGuid);
    },
    onNavigate() {
      this.$emit('navigate');
    },
    onStreetView() {
      this.$emit('streetview');
    },
    onVirtualTour() {
      this.$emit('virtualtour');
    },
    onVideo() {
      this.$emit('video');
    },
  },
});
